/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import {
  EMAIL_FOLLOWUP_RATE_AND_REVIEW_CAMPAIGN_ID,
  EMAIL_RATE_AND_REVIEW_CAMPAIGN_ID,
  ORDER_DETAILS_CAMPAIGN_ID,
  ORDER_HISTORY_CAMPAIGN_ID,
  PDP_CAMPAIGN_ID,
  RATE_AND_REVIEW_CAMPAIGN_ID,
  REVIEWS_PAGE_CAMPAIGN_ID,
  HOME_PAGE_CAMPAIGN_ID,
  ACCOUNT_PAGE_CAMPAIGN_ID,
} from '../constants';
import type { SubmitReviewPageType } from '../interface';

export const allowedPageTypes = new Set<SubmitReviewPageType>([
  'OrderDetails',
  'ProductDetail',
  'ProductReview',
  'OrderHistory',
  'RateAndReview',
  'EmailRateAndReview',
  'EmailFollowUpRateAndReview',
  'BV_PIE',
  'BV_PIE_FOLLOWUP',
  'home',
  'MyAccount',
]);

export function getReviewsCampaignID(pageType: SubmitReviewPageType | null): string | null {
  if (pageType === 'OrderDetails') {
    return ORDER_DETAILS_CAMPAIGN_ID;
  }

  if (pageType === 'ProductDetail') {
    return PDP_CAMPAIGN_ID;
  }

  if (pageType === 'ProductReview') {
    return REVIEWS_PAGE_CAMPAIGN_ID;
  }

  if (pageType === 'OrderHistory') {
    return ORDER_HISTORY_CAMPAIGN_ID;
  }

  if (pageType === 'RateAndReview') {
    return RATE_AND_REVIEW_CAMPAIGN_ID;
  }

  if (pageType === 'EmailRateAndReview') {
    return EMAIL_RATE_AND_REVIEW_CAMPAIGN_ID;
  }

  if (pageType === 'EmailFollowUpRateAndReview') {
    return EMAIL_FOLLOWUP_RATE_AND_REVIEW_CAMPAIGN_ID;
  }

  if (pageType === 'BV_PIE' || pageType === 'BV_PIE_FOLLOWUP') {
    return pageType;
  }

  if (pageType === 'home') {
    return HOME_PAGE_CAMPAIGN_ID;
  }

  if (pageType === 'MyAccount') {
    return ACCOUNT_PAGE_CAMPAIGN_ID;
  }

  return null;
}
